import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from './plugins/font-awesome'
import VueCookies from 'vue-cookies';

createApp(App)
  .use(router)
  .use(store)
  .use(VueCookies)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");
